import parsePhoneNumber, { AsYouType } from 'libphonenumber-js';
import appConfig from 'config';

const formattingInternationalNumber = (number, fallback = '', countryCode) => {
  if (number == null) return fallback;

  const cc = countryCode || appConfig.countryCode;
  const parsedNumber = parsePhoneNumber(number, cc);
  // +1 213 373 4253
  return parsedNumber ? parsedNumber.formatInternational() : fallback;
};

const formattingNationalNumber = (number, fallback = '', countryCode) => {
  if (number == null) return fallback;

  const cc = countryCode || appConfig.countryCode;
  const parsedNumber = parsePhoneNumber(number, cc);
  // (213) 373-4253
  return parsedNumber ? parsedNumber.formatNational() : fallback;
};

const parseNumber = (number, fallback = '', countryCode) => {
  if (number == null) return fallback;

  const cc = countryCode || appConfig.countryCode;
  const asYouType = new AsYouType(cc);
  asYouType.input(number);
  return asYouType.getChars() ?? fallback;
};

export default { formattingInternationalNumber, formattingNationalNumber, parseNumber };
